import { Link, useLocation, useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import { Layout, Button, message, Modal } from 'antd';
import { SwapLeftOutlined, UserOutlined } from '@ant-design/icons';
import LanguageSwitcher from '@common/LanguageSwitcher';
import QESG_AssessmentMixedLogo from '@images/QESG_Assessment_mixed.svg?react';
import { t } from '@/utils/translator';
import { useEffect, useState } from 'react';
const { Header: AntHeader } = Layout;
import useAuthStore from '@store/useAuthStore';
import UserProfileModal from '@components/common/UserProfileModal';
import i18n from '@/i18n';

function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const isMain = location.pathname === '/projects';
  const isAdmin = location.pathname.startsWith('/admin');
  const isClient = location.pathname.startsWith('/client');
  const isSiteEstimate =
    location.pathname.startsWith('/projects/') || location.pathname.startsWith('/v2/projects/');
  const user = useAuthStore((state) => state.user);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const logout = useAuthStore((state) => state.logout);
  const handleLogout = async () => {
    try {
      await logout();
      message.success('로그아웃 되었습니다.');
      navigate('/');
    } catch (err) {
      message.error('로그아웃 실패');
      console.error(err);
    }
  };

  const [HeaderBgColorClass, setHeaderBgColorClass] = useState('bg-transparent');
  const [isUserProfileModalOpen, setIsUserProfileModalOpen] = useState(false);

  useEffect(() => {
    if (isAdmin) {
      setHeaderBgColorClass('');
    } else if (isSiteEstimate || isClient) {
      setHeaderBgColorClass('bg-blue-9');
    } else if (isMain) {
      setHeaderBgColorClass('bg-blue-9');
    }
  }, [isAdmin, isClient, isMain, isSiteEstimate, location.pathname]);

  return (
    <AntHeader className={HeaderBgColorClass}>
      <div className={clsx('d-flex align-items-center justify-content-between')}>
        {(isMain || isAdmin || isClient) && isAuthenticated && (
          <Link to="/" className="lh-0" style={{ maxWidth: '130px', width: '100%' }}>
            <QESG_AssessmentMixedLogo className="h-100 w-100" />
          </Link>
        )}

        {isSiteEstimate && isAuthenticated && (
          <Link
            to="/projects"
            className="text-gray-1 hover:text-gray-1 active:text-gray-1 ml-auto fs-6"
          >
            <SwapLeftOutlined className="me-2" />
            {t('프로젝트 선택하기')}
          </Link>
        )}
        <div className={clsx(isSiteEstimate && 'ms-auto')}>
          <div className="d-inline-block text-light me-3">
            {i18n.language === 'ko' && `${user.company_name} - ${user.username}님 안녕하세요`}
            {i18n.language === 'en' && `Hello ${user.username} from ${user.company_name}`}
            {i18n.language === 'zh' && `${user.company_name} - ${user.username}，您好`}
          </div>
          <LanguageSwitcher className="me-2" />
          <Button className="me-2" onClick={() => setIsUserProfileModalOpen(true)}>
            <UserOutlined />
          </Button>

          {user.role === 'SUPER' && (
            <>
              <Button className="me-2" onClick={() => navigate('/admin/managing/project')}>
                운영관리
              </Button>
              <Button className="me-2" onClick={() => navigate('/admin/estimates/projects')}>
                산정 프로젝트 관리
              </Button>
            </>
          )}

          <Button onClick={() => handleLogout()}>{t('로그아웃')}</Button>
        </div>
      </div>
      <UserProfileModal
        open={isUserProfileModalOpen}
        onClose={() => setIsUserProfileModalOpen(false)}
      />
    </AntHeader>
  );
}

export default Header;
